<div class="filters-panel">
  <pwj-filters-panel-head [titleKey]="titleKey()" [icon]="icon()" />
  <ng-content />
</div>
